import { Loader2 } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { Button } from '@/components/ui/Button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/Dialog';
import {
  UpdatePairsWithAction,
  UpdatePairsWithDto,
} from '@/services/ProductsService';

interface RemoveConfirmModalProps {
  open: boolean;
  productId: string;
  pairsWithId: null | string;
  isLoading: boolean;
  onUpdatePairsWith: (updatePairsWithDto: UpdatePairsWithDto) => Promise<void>;
  onClose: (pairsWithId: null | string) => void;
}

export function RemoveConfirmModal({
  open,
  productId,
  pairsWithId,
  isLoading,
  onUpdatePairsWith,
  onClose,
}: RemoveConfirmModalProps) {
  const { t } = useTranslation('translation', {
    keyPrefix:
      'pages.VisionProduct.components.PairsWith.components.RemoveConfirmModal',
  });
  function handleClose() {
    onClose(null);
  }

  async function handleRemove() {
    if (!pairsWithId) {
      return null;
    }

    await onUpdatePairsWith({
      action: UpdatePairsWithAction.REMOVE,
      productId,
      pairsWithId,
    });

    onClose(null);
  }

  return (
    <Dialog open={open} onOpenChange={handleClose}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{t('title')}</DialogTitle>

          <DialogDescription>{t('description')}</DialogDescription>
        </DialogHeader>

        <DialogFooter>
          <Button variant="outline" onClick={handleClose}>
            {t('cancelButton')}
          </Button>

          <Button
            variant="destructive"
            onClick={handleRemove}
            disabled={isLoading}
          >
            {isLoading && <Loader2 className="animate-spin" />}
            {!isLoading && t('removeButton')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
